import { useState, useEffect } from "react";
import { PageLoader } from "../../components/loader";
import { useParams, useLocation } from "react-router-dom";
import { Typography, Box, Container } from '@mui/material';
import { NewsContent } from "../../components/news/NewsContent";
import { RelatedNewsSection } from "../../components/news/RelatedNewsSection";
import ArrowBack from '../../components/common/ArrowBack'
const NewsDetails = () => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [news, setNews] = useState(null);
    const [relatedNews, setRelatedNews] = useState([]);
    const { id } = useParams();
    const location = useLocation();
    const locationState = location.state || {};
    const allNews = locationState.news || [];
    
    useEffect(() => {
        if (id && allNews.length > 0) {
            const found = allNews.find(n => n.id === id);
            setNews(found || null);
    
            const related = allNews
                .filter(n => n.id !== id)
                .slice(0, 3); // solo 3 relacionadas
            setRelatedNews(related);
            setLoading(false);
        } else {
            setError("No se encontraron noticias.");
            setLoading(false);
        }
    
        window.scrollTo(0, 0);
    }, [id, allNews]);

    if (loading) return <PageLoader message="Cargando su noticia" />;
    if (error) return (
        <Container className="flex items-center justify-center h-screen">
            <Typography variant="h5" color="error" className="text-center">
                {error}
            </Typography>
        </Container>
    );

    if (!news) return (
        <Container className="flex items-center justify-center h-screen">
            <Typography variant="h5" className="text-center">
                No se encontró la noticia solicitada
            </Typography>
        </Container>
    );

    return (
        <Box
            sx={{
                minHeight: '100vh',
                background: 'bg-gray-100',
                py: 4,
                position: 'relative',
                overflow: 'hidden', // Evita que el contenido se desborde
            }}
        >
            <Box
                sx={{
                    maxWidth: '1600px', // Limitar el ancho máximo
                    mx: 'auto',
                    px: { xs: 2, md: 4 },
                    display: 'flex',
                    flexDirection: { xs: 'column', md: 'row' },
                    gap: 4,
                    overflow: 'hidden', // Asegura que nada se desborde
                }}
            >
                {/* Contenido principal */}
                <Box
                    sx={{
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 3,
                        overflow: 'hidden', // Limitar desbordamientos
                    }}
                >
                    <Box sx={{ ml: 1 }}>
                        <ArrowBack/>
                    </Box>
                    <NewsContent news={news} />
                
                    {/* RelatedNews en móvil */}
                    <Box sx={{ display: { xs: 'block', md: 'none' }, mt: 3 }}>
                        <RelatedNewsSection
                            relatedNews={relatedNews}
                            allNews={allNews}
                            isMobile={true}
                        />
                    </Box>
                </Box>
    
                {/* Sidebar en escritorio */}
                <Box
                    sx={{
                        width: { md: 350 },
                        position: 'sticky',
                        top: 20,
                        alignSelf: 'flex-start',
                        display: { xs: 'none', md: 'block' },
                        overflow: 'hidden', // Evitar desbordamiento en el sidebar
                    }}
                >
                    <RelatedNewsSection
                        relatedNews={relatedNews}
                        allNews={allNews}
                        isMobile={false}
                    />
                </Box>
            </Box>
        </Box>
    );
}    

export default NewsDetails;